export default "__VITE_ASSET__DFHYsjNE__"